import { request, type AuthSession, type AuthUser } from '../../shared/api/request'

type AdminLoginResult = { accessToken: string; refreshToken: string; session: { userId: string; tenantId: string; username: string; displayName?: string | null; avatarUrl?: string | null; organizationId?: string | null } }
type Authorization = { roles: Array<{ code: string }> }

export async function loginWithUsername(username: string, password: string): Promise<AuthSession> {
  const result = await request<AdminLoginResult>({ url: '/api/auth/login', method: 'POST', auth: false, data: { username, password, terminalType: 'PWA' } })
  const authorization = await request<Authorization>({ url: '/api/auth/me/authorization', accessToken: result.accessToken, skipRefresh: true })
  const roleCodes = authorization.roles.map((role) => role.code)
  const user: AuthUser = { id: result.session.userId, name: result.session.displayName || result.session.username, avatarUrl: result.session.avatarUrl || '', tenantId: result.session.tenantId, organizationId: result.session.organizationId || '', roleGroup: roleCodes.some((code) => code.includes('LAWYER') || code.includes('ADMIN')) ? 'LAWYER' : 'NORMAL_USER', roleCodes }
  return { accessToken: result.accessToken, refreshToken: result.refreshToken, user }
}

export async function sendRegistrationCode(email: string): Promise<void> {
  await request<void>({ url: '/api/auth/register/code', method: 'POST', auth: false, data: { email } })
}

export async function registerWithEmail(email: string, password: string, code: string): Promise<AuthSession> {
  const result = await request<AdminLoginResult>({ url: '/api/auth/register', method: 'POST', auth: false, data: { email, password, code } })
  const authorization = await request<Authorization>({ url: '/api/auth/me/authorization', accessToken: result.accessToken, skipRefresh: true })
  const roleCodes = authorization.roles.map((role) => role.code)
  const user: AuthUser = { id: result.session.userId, name: result.session.displayName || result.session.username, avatarUrl: result.session.avatarUrl || '', tenantId: result.session.tenantId, organizationId: result.session.organizationId || '', roleGroup: roleCodes.some((code) => code.includes('LAWYER') || code.includes('ADMIN')) ? 'LAWYER' : 'NORMAL_USER', roleCodes }
  return { accessToken: result.accessToken, refreshToken: result.refreshToken, user }
}

export async function sendPasswordResetCode(email: string): Promise<void> {
  await request<void>({ url: '/api/auth/password-reset/code', method: 'POST', auth: false, data: { email } })
}

export async function resetPassword(email: string, code: string, newPassword: string): Promise<void> {
  await request<void>({ url: '/api/auth/password-reset/confirm', method: 'POST', auth: false, data: { email, code, newPassword } })
}

export async function logoutSession(): Promise<void> {
  await request<void>({ url: '/api/auth/logout', method: 'POST' })
}
